import React, { useEffect } from 'react';

import { Footer, Header } from '../../components';
import { useHeader } from '../../contexts/useHeader';
import { useNavigation } from '../../contexts/useNavigation';
import homeLinks from '../../data/mock.data.homepage';

import {
  ContactUsSection,
  ExpertiseSection,
  HowWeWorkSection,
  Intro,
  ProjectsSection,
} from './components';

const HomePage = () => {
  const { headerDimensions } = useHeader();
  const {
    scrollToAnchor,
    setScrollToAnchor,
  } = useNavigation();

  useEffect(() => {
    if (scrollToAnchor != null) {
      const element =
        document.getElementById(
          scrollToAnchor
        );

      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }

      setScrollToAnchor(null);
    }
  }, [
    scrollToAnchor,
    setScrollToAnchor,
  ]);

  return (
    <>
      <Header links={homeLinks} />

      <Intro />

      <ExpertiseSection
        marginTop={
          headerDimensions?.height || 0
        }
      />

      <HowWeWorkSection />

      <ProjectsSection />

      <ContactUsSection
        marginTop={
          headerDimensions?.height || 0
        }
      />

      <Footer />
    </>
  );
};

export default HomePage;